import { z } from 'zod'

const HexColorSchema = z.string().regex(/^#([0-9A-Fa-f]{3}){1,2}$/)

export type RGB = z.infer<typeof HexColorSchema>

export function hexToRgb(hex: string): [number, number, number] {
  const { success } = HexColorSchema.safeParse(hex)

  if (!success) {
    throw new Error('invalid hex color')
  }

  const r = parseInt(hex.slice(1, 3), 16)
  const g = parseInt(hex.slice(3, 5), 16)
  const b = parseInt(hex.slice(5, 7), 16)
  return [r, g, b]
}

// Returns the hex color as an `rgba()` string at the given alpha (0–1). Falls
// back to the raw value if it is not a parseable hex color.
export function hexToRgba(hex: string, alpha: number): string {
  try {
    const [r, g, b] = hexToRgb(hex)
    return `rgba(${r}, ${g}, ${b}, ${alpha})`
  } catch {
    return hex
  }
}

export function getContrastYIQ(
  inputColor: [number, number, number] | RGB,
): 'black' | 'white' {
  let rgb: [number, number, number]
  try {
    if (typeof inputColor === 'string') {
      rgb = hexToRgb(inputColor as RGB)
    } else {
      rgb = inputColor
    }

    const [r, g, b] = rgb
    const yiq = (r * 299 + g * 587 + b * 114) / 1000
    return yiq >= 128 ? 'black' : 'white'
  } catch (e) {
    return 'black'
  }
}
